export default __webpack_public_path__ + "static/media/comedora-producto-eduardiana.38d520a2.png";